import faker from "faker";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { formatDistance } from "date-fns";
import { Link as RouterLink } from "react-router-dom";
import arrowIosForwardFill from "@iconify/icons-eva/arrow-ios-forward-fill";

// 2022.11 텍스트 에디터 추가로 게시글이 델타값으로 나오기 때문에 변환하고자 사용
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';

// material
import {
  Box,
  Stack,
  Link,
  Card,
  Button,
  Divider,
  Typography,
  CardHeader,
} from "@mui/material";
// utils
import { mockImgCover, mockImgCovers } from "../../../utils/mockImages";
//
import Scrollbar from "../../elements/Scrollbar";
import { useEffect, useState } from "react";

import { axios } from "../../../commons";

// ----------------------------------------------------------------------

// const lenNews = 5;
// const NEWS = [...Array(lenNews)].map((_, index) => {
//   const setIndex = index + 1;
//   return {
//     title: faker.name.title(),
//     description: faker.lorem.paragraphs(),
//     // image: mockImgCover(setIndex),
//     postedAt: faker.date.soon(),
//   };
// });

// ----------------------------------------------------------------------

NewsItem.propTypes = {
  news: PropTypes.object.isRequired,
};

function NewsItem({ news }) {
  const {
    //image,
    title,
    description,
    postedAt,
  } = news;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {/* <Box
        component="img"
        alt={title}
        // src={image}
        sx={{ width: 48, height: 48, borderRadius: 1.5 }}
      /> */}
      <Box sx={{ maxWidth: 815, minWidth: 815 }}>
        <Link to="#" color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap style={{textOverflow: 'ellipsis'}}>
            {title}
          </Typography>
        </Link>
        <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          {description}
        </Typography>
      </Box>
      <Typography
        variant="caption"
        sx={{ pr: 3, flexShrink: 0, color: "text.secondary" }}
      >
        {formatDistance(postedAt, new Date())}
      </Typography>
    </Stack>
  );
}

export default function AppNewArticleList() {
  const [articles, setArticles] = useState();
  async function getNewArticles() {
    try {
      // 새로운 게시글 목록 서버에 요청
      const { data } = await axios.get(`/admin/board/dashboard/newArticleList`);


      const realArticleList = data.articleList.map((doc) => {
        let title = convertTitle(doc.title);
        const realArticle = {
          title: title,
          description: doc.description,
          postedAt: new Date(doc.postedAt),
        };
        return realArticle;
      });

      setArticles(realArticleList);
    } catch (err) {
      console.error(err);

      if (err.response) {
        alert(err.response.data.error);
      }
    }
  }

  // delta content의 text만 filter해서 가공
  const convertTitle = (data) => {
    let title = '';
    // 내용이 delta인 경우
    if(data.includes('insert')) {
      const content = JSON.parse(data);

      // 이미지를 url 초기화
      for(let i=0; i<content.length; i++) {
        if(content[i].insert.image !== undefined) {
          content[i].insert.image = '';
        }
      }
      
      // html로 변환후 text만 추출
      let cfg = {};
      let converter = new QuillDeltaToHtmlConverter(content, cfg);
      let html = converter.convert();
      let div = document.createElement('div');
      div.innerHTML = `${html}`;
      title = div.textContent;  // div 태그 영역안의 텍스트 추출

    } else {
      title = data;
    }
    return title;
  }

  useEffect(() => {
    getNewArticles();
  }, []);

  function handleClick(e) {
    // article 페이지로 이동
    window.location.replace("/articles");
  }
  return (
    <Card sx={{ minHeight: 460, maxHeight: 460, maxWidth: 983 }}>
      <CardHeader title="New Articles" />

      <Scrollbar sx={{ minHeight: 335, maxHeight: 335 }}>
        <Stack spacing={1} sx={{ p: 3, pr: 0 }}>
          {articles &&
            articles.map((news) => <NewsItem key={news.title} news={news} />)}
        </Stack>
      </Scrollbar>

      <Divider sx={{ minHeight: 2, maxHeight: 2 }} />

      <Box sx={{ p: 2, textAlign: "right" }}>
        <Button
          to="#"
          size="small"
          color="inherit"
          component={RouterLink}
          endIcon={<Icon icon={arrowIosForwardFill} />}
          onClick={handleClick}
        >
          View all
        </Button>
      </Box>
    </Card>
  );
}
